// ============================================================================
// Medidor de tiempo real de uso del ERP.
// ============================================================================
// Detecta actividad del usuario (clics, teclado, movimiento, scroll) y cada
// 60 segundos reporta un bloque de uso a la RPC registrar_uso() de Supabase,
// SOLO si hubo actividad en los últimos 5 minutos y la pestaña está visible.
// Así el acumulado refleja tiempo de trabajo real, no pestañas abandonadas.
// El resultado se consulta en Informes → "Tiempo de uso del sistema".
import { state } from "./state.js";
import { supa } from "./supabaseClient.js";

const UMBRAL_INACTIVIDAD_MS = 5 * 60 * 1000;  // 5 min sin actividad → no cuenta
const INTERVALO_REPORTE_MS = 60 * 1000;       // un bloque por minuto

let ultimaActividad = 0;
let timer = null;

function marcarActividad() {
  ultimaActividad = Date.now();
}

export function iniciarTrackerUso() {
  if (timer) return; // ya está corriendo
  ultimaActividad = Date.now();
  ["click", "keydown", "pointerdown", "mousemove", "touchstart", "wheel"].forEach(ev =>
    document.addEventListener(ev, marcarActividad, { passive: true, capture: true })
  );
  timer = setInterval(async () => {
    if (document.hidden) return;                                   // pestaña en segundo plano
    if (Date.now() - ultimaActividad > UMBRAL_INACTIVIDAD_MS) return; // usuario ausente
    try {
      await supa.rpc("registrar_uso", {
        p_segundos: Math.round(INTERVALO_REPORTE_MS / 1000),
        p_email: state.usuarioEmail || null,
        p_nombre: state.usuarioNombre || null
      });
    } catch { /* sin conexión: se pierde el bloque, no es crítico */ }
  }, INTERVALO_REPORTE_MS);
}

export function detenerTrackerUso() {
  if (timer) { clearInterval(timer); timer = null; }
}

// Consulta para el informe (RLS: cada usuario ve lo suyo; el admin ve todo).
export async function cargarUsoDiario(desde, hasta) {
  let q = supa.from("uso_diario").select("*").order("fecha", { ascending: false }).limit(1000);
  if (desde) q = q.gte("fecha", desde);
  if (hasta) q = q.lte("fecha", hasta);
  const { data, error } = await q;
  if (error) { console.error("⚠️ Error cargando uso diario:", error.message); return []; }
  return data || [];
}
